import { FreeSpinsInfoEvent, SpinResponse } from '@cgs/data-access';
import { Container, TextSceneObject } from '@cgs/wge';
import {
  AbstractListener,
  GAME_STATE_MACHINE_PROVIDER_TOKEN,
  GameStateMachine,
  GameStateMachineNotifierComponent,
  GameStateMachineStates,
  IGameStateMachineProvider,
  ISpinParams,
  RESOURCES_COMPONENT_TOKEN,
  ResourcesComponent,
  T_GameStateMachineNotifierComponent,
  T_ISpinParams,
} from '@cgs/machines';

export const AUTO_SPINS_COUNTER_CONTROLLER_TOKEN = Symbol('AUTO_SPINS_COUNTER_CONTROLLER_TOKEN');

export class AutoSpinsCounterController implements AbstractListener {
  private _count: number;
  private _gameStateMachine: GameStateMachine<SpinResponse>;
  private _autoSpinCounter: TextSceneObject | null;
  private _spinParams: ISpinParams;
  public unlimitedSpins: boolean;

  constructor(container: Container) {
    this._autoSpinCounter =
      container
        .resolve<ResourcesComponent>(RESOURCES_COMPONENT_TOKEN)
        .footer?.findById<TextSceneObject>('autoSpinCounter') || null;
    this._spinParams = container.resolve<ISpinParams>(T_ISpinParams);
    this._gameStateMachine = container.resolve<IGameStateMachineProvider>(
      GAME_STATE_MACHINE_PROVIDER_TOKEN
    ).gameStateMachine;
    container
      .resolve<GameStateMachineNotifierComponent>(T_GameStateMachineNotifierComponent)
      .notifier.addListener(this);
    this.unlimitedSpins = false;
  }

  get count(): number {
    return this._count;
  }

  set count(value: number) {
    if (!this._autoSpinCounter) {
      return;
    }

    this._count = value;
    if (this._count > 0) {
      this._autoSpinCounter.text = this._count.toString();
    } else if (this._count == 0) {
      this._autoSpinCounter.text = '';
    } else {
      this._autoSpinCounter.text = '\u221e';
    }
  }

  public onStateEntered(slotState: string): void {
    switch (slotState) {
      case GameStateMachineStates.Accelerate:
        this.onAccelerateEntered();
        break;
      case GameStateMachineStates.Stop:
        this.onStopEntered();
        break;
      default:
        break;
    }
  }

  public onStateExited(_slotState: string): void {
    //
  }

  private onAccelerateEntered(): void {
    if (
      this._spinParams.autoSpin &&
      (!this._gameStateMachine.curResponse.isFreeSpins ||
        this._gameStateMachine.curResponse.freeSpinsInfo!.event ==
          FreeSpinsInfoEvent.FreeSpinsFinished) &&
      !this._gameStateMachine.curResponse.isRespin
    ) {
      this.count--;
    }
  }

  private onStopEntered(): void {
    if (
      this._spinParams.autoSpin &&
      (!this._gameStateMachine.curResponse.isFreeSpins ||
        this._gameStateMachine.curResponse.freeSpinsInfo!.event ==
          FreeSpinsInfoEvent.FreeSpinsFinished)
    ) {
      if (this.count == 0) {
        this._spinParams.autoSpin = false;
        this.unlimitedSpins = false;
      }
    }
  }
}
